import * as React from "react";
const SvgFiRrPartyBell = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-party-bell_svg__a)">
      <path
        fill="#062147"
        d="M13.97 2.971a2.64 2.64 0 0 0-1.369-1.96A8.51 8.51 0 0 0 2.508 2.507 8.51 8.51 0 0 0 1.01 12.601a2.64 2.64 0 0 0 1.962 1.37q.204.03.408.03c.736 0 1.453-.292 1.978-.816l7.827-7.828a2.8 2.8 0 0 0 .786-2.386m-2.2.972-7.827 7.828a.78.78 0 0 1-.678.221.65.65 0 0 1-.492-.334c-1.352-2.526-.878-5.707 1.15-7.735a6.6 6.6 0 0 1 4.66-1.914c1.053 0 2.111.25 3.075.766a.65.65 0 0 1 .333.491.8.8 0 0 1-.222.678zM4 19.501a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m20-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-10-2a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m10 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-5-19a1.5 1.5 0 1 1 3.001 0 1.5 1.5 0 0 1-3 0m4.683 4.731C22.374 9.455 21.163 10 19.75 10c-2.069 0-3.214-1.086-3.829-1.67l-.104-.098a1 1 0 0 1 1.367-1.46l.114.106C17.824 7.378 18.48 8 19.751 8c.62 0 1.408-.146 2.567-1.229a1 1 0 1 1 1.366 1.461zM10.998 19.224c.04 1.583-.623 3.252-1.772 4.464a1 1 0 1 1-1.45-1.376c.781-.823 1.25-1.987 1.224-3.036-.039-1.538-.413-2.2-.775-2.645a1 1 0 1 1 1.552-1.261c.804.988 1.181 2.178 1.222 3.855M19 19.98c0 1.396-.383 2.548-1.205 3.626a1 1 0 1 1-1.59-1.212c.558-.73.795-1.453.795-2.413 0-1.465-.738-2.24-.77-2.272a1.007 1.007 0 0 1 .003-1.409.995.995 0 0 1 1.4-.017c.14.136 1.367 1.394 1.367 3.698"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-party-bell_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPartyBell;
